// extracted by mini-css-extract-plugin
export default {"accountHeader":"Ej-z","newDesignAccountHeader":"Fj-z","primeBadge":"Gj-z","logout":"Hj-z"};